import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import productsEn from './locales/en/products.json';
import productsFr from './locales/fr/products.json';
import productsNl from './locales/nl/products.json';
import productsDe from './locales/de/products.json';
import productsIt from './locales/it/products.json';
import productsEs from './locales/es/products.json';

import settingsEn from './locales/en/settings.json';
import settingsFr from './locales/fr/settings.json';
import settingsNl from './locales/nl/settings.json';
import settingsDe from './locales/de/settings.json';
import settingsIt from './locales/it/settings.json';
import settingsEs from './locales/es/settings.json';

import dashboardEn from './locales/en/dashboard.json';
import dashboardFr from './locales/fr/dashboard.json';
import dashboardNl from './locales/nl/dashboard.json';
import dashboardDe from './locales/de/dashboard.json';
import dashboardIt from './locales/it/dashboard.json';
import dashboardEs from './locales/es/dashboard.json';

import resellersEn from './locales/en/resellers.json';
import resellersFr from './locales/fr/resellers.json';
import resellersNl from './locales/nl/resellers.json';
import resellersDe from './locales/de/resellers.json';
import resellersIt from './locales/it/resellers.json';
import resellersEs from './locales/es/resellers.json';

import sidebarEn from './locales/en/sidebar.json';
import sidebarFr from './locales/fr/sidebar.json';
import sidebarNl from './locales/nl/sidebar.json';
import sidebarDe from './locales/de/sidebar.json';
import sidebarIt from './locales/it/sidebar.json';
import sidebarEs from './locales/es/sidebar.json';

import commonEn from './locales/en/common.json';
import commonFr from './locales/fr/common.json';
import commonNl from './locales/nl/common.json';
import commonDe from './locales/de/common.json';
import commonIt from './locales/it/common.json';
import commonEs from './locales/es/common.json';

import productDetailEn from './locales/en/productDetail.json';
import productDetailFr from './locales/fr/productDetail.json';
import productDetailNl from './locales/nl/productDetail.json';
import productDetailDe from './locales/de/productDetail.json';
import productDetailIt from './locales/it/productDetail.json';
import productDetailEs from './locales/es/productDetail.json';

import alertsEn from './locales/en/alerts.json';
import alertsFr from './locales/fr/alerts.json';
import alertsNl from './locales/nl/alerts.json';
import alertsDe from './locales/de/alerts.json';
import alertsIt from './locales/it/alerts.json';
import alertsEs from './locales/es/alerts.json';

import adminEn from './locales/en/admin.json';
import adminFr from './locales/fr/admin.json';
import adminNl from './locales/nl/admin.json';
import adminDe from './locales/de/admin.json';
import adminIt from './locales/it/admin.json';
import adminEs from './locales/es/admin.json';

import loginEn from './locales/en/login.json';
import loginFr from './locales/fr/login.json';
import loginNl from './locales/nl/login.json';
import loginDe from './locales/de/login.json';
import loginIt from './locales/it/login.json';
import loginEs from './locales/es/login.json';

const resources = {
  en: {
    products: productsEn,
    settings: settingsEn,
    dashboard: dashboardEn,
    resellers: resellersEn,
    sidebar: sidebarEn,
    common: commonEn,
    productDetail: productDetailEn,
    alerts: alertsEn,
    admin: adminEn,
    login: loginEn,
  },
  fr: {
    products: productsFr,
    settings: settingsFr,
    dashboard: dashboardFr,
    resellers: resellersFr,
    sidebar: sidebarFr,
    common: commonFr,
    productDetail: productDetailFr,
    alerts: alertsFr,
    admin: adminFr,
    login: loginFr,
  },
  nl: {
    products: productsNl,
    settings: settingsNl,
    dashboard: dashboardNl,
    resellers: resellersNl,
    sidebar: sidebarNl,
    common: commonNl,
    productDetail: productDetailNl,
    alerts: alertsNl,
    admin: adminNl,
    login: loginNl,
  },
  de: {
    products: productsDe,
    settings: settingsDe,
    dashboard: dashboardDe,
    resellers: resellersDe,
    sidebar: sidebarDe,
    common: commonDe,
    productDetail: productDetailDe,
    alerts: alertsDe,
    admin: adminDe,
    login: loginDe,
  },
  it: {
    products: productsIt,
    settings: settingsIt,
    dashboard: dashboardIt,
    resellers: resellersIt,
    sidebar: sidebarIt,
    common: commonIt,
    productDetail: productDetailIt,
    alerts: alertsIt,
    admin: adminIt,
    login: loginIt,
  },
  es: {
    products: productsEs,
    settings: settingsEs,
    dashboard: dashboardEs,
    resellers: resellersEs,
    sidebar: sidebarEs,
    common: commonEs,
    productDetail: productDetailEs,
    alerts: alertsEs,
    admin: adminEs,
    login: loginEs,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

// Listen for language changes and save to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
